<template>
  <div class="fb wrapper" @click="jump">
    <div class="left-container">
      <div class="left-container_title">
        {{ details.type ? '离寝' : '归寝' }}
      </div>
      <div class="left-container_time">
        {{ details.type ? '上学时间' : '下学时间' }} ：{{ details.time }}
      </div>
      <div class="left-container_chart">
        <canvas :width="size" :height="size"></canvas>
        <div class="fb fb-col fb-main-center fb-cross-center">
          <div class="c-006AFE font-32">
            <span>{{ details.matched }}</span>
          </div>
          <div class="font-24 c-191F25">
            <span>{{ details.type ? '已离' : '已归' }}</span>
          </div>
        </div>
      </div>
      <div class="fb fb-main-center fb-cross-center font-24 c-191F25">
        <span
          >{{ details.type ? '应离寝' : '应归寝' }} ：{{ details.total }}</span
        >
      </div>
    </div>
    <div class="fb right-container c-191F25">
      <div class="right-container_box">
        <div class="fb">
          <div class="fb fb-col font-24 fb-main-center fb-cross-center">
            {{ details.type ? '未离寝' : '未归寝' }}</div
          >
          <div
            class="fb fb-col number font-36 fb-main-center fb-cross-center"
            >{{ details.unMatched }}</div
          >
        </div>
      </div>
      <div class="right-container_box">
        <div class="fb">
          <div class="fb fb-col font-24 fb-main-center fb-cross-center"
            >请假</div
          >
          <div
            class="fb fb-col number font-36 fb-main-center fb-cross-center"
            >{{ details.leave }}</div
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      size: 100, // 圆形进度条宽度和高度
      canvasEl: null, // 进度条画布
      cacheCanvas: null, // 进度条画布（临时）
      lineWidth: 8 //  进度条宽度
    }
  },
  watch: {
    details(details) {
      if (details.total) {
        this.init()
      }
    }
  },
  computed: {
    computedProgress() {
      let _progress = Math.ceil(
        (this.details.matched * 100) / this.details.total
      )
      return _progress
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.cacheCanvas = document.createElement('canvas')
      this.cacheCanvas.width = this.size
      this.cacheCanvas.height = this.size

      this.canvasEl = this.$el.getElementsByTagName('canvas')[0]
      this.methodDrowProgress()
    },
    methodDrowProgress() {
      let _ctx = this.cacheCanvas.getContext('2d')
      let _offset = this.size / 2
      // 保存状态(1)
      _ctx.save()
      _ctx.lineWidth = this.lineWidth
      _ctx.lineCap = 'round'
      _ctx.translate(_offset, _offset)
      _ctx.clearRect(-_offset, -_offset, this.size, this.size)
      _ctx.rotate(-Math.PI / 2)

      // 绘制进度条底部圆形
      _ctx.beginPath()
      _ctx.arc(0, 0, this.size / 2 - this.lineWidth, 0, Math.PI * 2, true)
      _ctx.strokeStyle = '#dfdfe0'
      _ctx.stroke()

      // 绘制进度条
      if (this.computedProgress) {
        _ctx.beginPath()
        _ctx.arc(
          0,
          0,
          this.size / 2 - this.lineWidth,
          0,
          (Math.PI * 2 * this.computedProgress) / 100,
          false
        )
        _ctx.strokeStyle = '#006AFE'
        _ctx.stroke()
      }

      // 返回到状态(1)
      _ctx.restore()

      let _ctx2 = this.canvasEl.getContext('2d')
      _ctx2.clearRect(0, 0, this.size, this.size)
      _ctx2.drawImage(this.cacheCanvas, 0, 0, this.size, this.size)
    },
    jump() {
      this.$emit('jump', this.details)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  height: 210px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: -16px 0 0 #f6f6f6;
  .left-container {
    flex: 1;
    padding: 10px 15px;
    border-right: 1px solid #f0f0f0;
    .left-container_title {
      font-size: 16px;
      color: #006afe;
      font-weight: bold;
      height: 23px;
      line-height: 23px;
    }
    .left-container_time {
      padding: 5px 0px;
      font-size: 12px;
      color: #171a1d;
      height: 16px;
      line-height: 16px;
    }
    .left-container_chart {
      position: relative;
      margin-top: 5px;
      height: 124px;
      > * {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .right-container {
    flex: 0 0 76px;
    flex-wrap: wrap;
    > .right-container_box {
      width: 100%;
      &:first-child {
        border-bottom: 1px solid #f0f0f0;
      }
      > .fb {
        flex-wrap: wrap;
        height: 100%;
        padding: 12px 0px;
        > .fb-col {
          width: 100%;
          &.number {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
